module.exports = __webpack_public_path__ + "static/Predict-Handle-SCM-Delays-2b59beb67dbc87a9b4da4b0c983da19d.jpg";